import {ThemeModeSwitcher} from '../../../partials'

const Topbar = () => (
  <div className='d-flex align-items-center flex-shrink-0'>
    <div className='d-flex align-items-center ms-3 ms-lg-4'>
      <ThemeModeSwitcher toggleBtnClass='btn-color-gray-700 btn-active-color-primary btn-outline btn-outline-secondary w-40px h-40px' />
    </div>
  </div>
)

export {Topbar}
